import { render, staticRenderFns } from "./LayoutSwitch.vue?vue&type=template&id=c8fee37e&scoped=true&"
import script from "./LayoutSwitch.vue?vue&type=script&lang=js&"
export * from "./LayoutSwitch.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSwitch.vue?vue&type=style&index=0&id=c8fee37e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../.yarn/__virtual__/vue-loader-virtual-783d792af9/0/cache/vue-loader-npm-15.10.0-778eb54c35-1bf6c9ffea.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fee37e",
  null
  
)

export default component.exports